import React, { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getHintIcon } from '@phoenix/design-system/frontend/ui/form';
import { cx } from '@emotion/css';

interface InfoMessageProps extends HTMLAttributes<HTMLElement> {
  dataTestId?: string;
}

export const InfoMessage: FC<PropsWithChildren<InfoMessageProps>> = ({ children, className, dataTestId, ...props }) => {
  return (
    <div className={cx('flex space-x-2 stihl-text-body-default-reg', className)} data-testid={dataTestId} {...props}>
      <PhoenixIcon icon={getHintIcon('info') as string} className="h-6 w-4 text-secondary" />
      <span className="w-fit">{children}</span>
    </div>
  );
};
